import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { getClassNameFactory } from "../../utilities/classNames";
import AlertCircleExcIcon from "@dcl/icons/esm/ui/alert-circle-exc";
import AlertTriangleExp from "@dcl/icons/esm/ui/alert-triangle-exp";
import CheckCircleIcon from "@dcl/icons/esm/ui/check-circle-08";
import CloseIcon from "@dcl/icons/esm/ui/cross";
import OpenInNewTab from "@dcl/icons/esm/ui/open-in-new-tab";
import Heading, { types } from "../../elements/Heading";
import Link from "../../elements/Link";
import { Rank } from "../../core/types";
import { AlertBannerType } from "./AlertBannerConstants";

var renderAlertStateIcon = function renderAlertStateIcon(bannerType) {
  switch (bannerType) {
    case AlertBannerType.ATTENTION:
      return /*#__PURE__*/React.createElement(AlertTriangleExp, {
        width: 28
      });

    case AlertBannerType.CONFIRMATION:
      return /*#__PURE__*/React.createElement(CheckCircleIcon, {
        width: 28
      });

    case AlertBannerType.INFORMATION:
      return /*#__PURE__*/React.createElement(AlertCircleExcIcon, {
        width: 28
      });

    case AlertBannerType.WARNING:
      return /*#__PURE__*/React.createElement(AlertCircleExcIcon, {
        width: 28
      });
  }
};

var AlertBanner = function AlertBanner(_ref) {
  var bannerType = _ref.bannerType,
      title = _ref.title,
      _ref$headingRank = _ref.headingRank,
      headingRank = _ref$headingRank === void 0 ? Rank.Second : _ref$headingRank,
      children = _ref.children,
      link = _ref.link,
      button = _ref.button,
      className = _ref.className,
      role = _ref.role,
      shouldShowAlertBanner = _ref.shouldShowAlertBanner;
  var getClassName = getClassNameFactory(AlertBanner.displayName);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isClosed = _useState2[0],
      setClosed = _useState2[1];

  useEffect(function () {
    if (isClosed && shouldShowAlertBanner) {
      setClosed(false);
    }
  }, [shouldShowAlertBanner]);

  var handleClick = function handleClick() {
    setClosed(true);

    if (button !== null && button !== void 0 && button.onClick) {
      button.onClick();
    }
  };

  if (isClosed) {
    return null;
  }

  var isColoredWarningText = !title && bannerType === AlertBannerType.WARNING;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(getClassName({
      modifiers: classNames(bannerType)
    }), className)
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "wrapper"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "icon"
    })
  }, renderAlertStateIcon(bannerType)), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "content"
    }),
    role: role
  }, title && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "title"
    })
  }, /*#__PURE__*/React.createElement(Heading, {
    rank: headingRank,
    type: types.Small
  }, /*#__PURE__*/React.createElement("b", null, title))), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "textContainer"
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "text",
      modifiers: classNames(isColoredWarningText && "colored")
    })
  }, children), link && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "link",
      modifiers: classNames(button && "rightSpace")
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: link.linkHref,
    newWindow: true,
    iconRight: /*#__PURE__*/React.createElement(OpenInNewTab, {
      width: 16
    })
  }, link.linkText, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "screenReaderOnly",
      utilities: "hiddenVisually"
    })
  }, "(opens in a new tab)"))), button && /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "button"
    }),
    type: "button",
    onClick: handleClick
  }, button.buttonText || /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "screenReaderOnly",
      utilities: "hiddenVisually"
    })
  }, "".concat(bannerType, " banner close")), /*#__PURE__*/React.createElement(CloseIcon, {
    width: 16
  }))))));
};

AlertBanner.displayName = "AlertBanner";
export default AlertBanner;